import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  object: { value: "", matchMode: "contains" },
  name: { value: "", matchMode: "contains" },
  subject: { value: "", matchMode: "contains" },
};

export const useFilterNotificationStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
